// @flow

import * as React from 'react';
import styled, { withTheme, css } from 'styled-components';
import { Text } from './Text';
import { Plus } from './svg';
import { VSpacer } from './Layout';

type State = {
  expanded: boolean,
  contentHeight: number,
};

type Props = {
  title: string,
  children: React.Node,
  theme: any,
};

class Expandable extends React.Component<Props, State> {
  state = {
    expanded: false,
    contentHeight: 0,
  };

  contentArea;
  setContentRef = (ref) => (this.contentArea = ref);

  componentDidMount() {
    window.addEventListener('resize', this.setContentHeight);
    this.setContentHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setContentHeight);
  }

  componentDidUpdate() {
    this.setContentHeight();
  }

  toggleExpanded = () => this.setState({ expanded: !this.state.expanded });

  setContentHeight = () => {
    const contentHeight = this.contentArea ? this.contentArea.clientHeight : 0;

    if (contentHeight !== 0 && contentHeight !== this.state.contentHeight) {
      this.setState({ contentHeight });
    }
  };

  render() {
    const { title, children, theme } = this.props;
    const { expanded, contentHeight } = this.state;
    const titleColor = theme ? theme.actionColor : 'currentColor';

    return (
      <React.Fragment>
        <TitleContainer onClick={this.toggleExpanded}>
          <Rotating rotated={expanded}>
            <Plus width="1.75em" height="1.75em" color={titleColor} />
          </Rotating>
          <TitleText color={titleColor}>{title}</TitleText>
        </TitleContainer>

        <SlideDown visible={expanded} contentHeight={contentHeight}>
          <ContentContainer ref={this.setContentRef}>
            <VSpacer small={2} medium={3} />
            {children}
          </ContentContainer>
        </SlideDown>
      </React.Fragment>
    );
  }
}

export default withTheme(Expandable);

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const transition = css`
  transition: 0.25s;
`;

const SlideDown = styled.div`
  max-height: ${(props) => (props.visible ? props.contentHeight + 'px' : 0)};
  overflow-y: hidden;
  ${transition};
`;

const Rotating = styled.span`
  display: flex;
  transform: ${(props) => (props.rotated ? 'rotate(45deg)' : '')};
  ${transition};
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const TitleText = styled(Text)`
  margin-left: 0.5em;
  color: ${(props) => props.color};
`;
